import type { CookieEntry } from '@lib/analytics/cookie-registry';
import CountBadge from './count-badge';

const CookieItem = ({ cookie }: { cookie: CookieEntry }) => (
  <div className="rounded-lg bg-brand-neutral-100 flex flex-col gap-2 p-4">
    <div className="flex items-center gap-2">
      <span className="font-body font-bold text-sm leading-[1.5] text-brand-neutral-900">
        {cookie.name}
      </span>
      <CountBadge count={1} aria-hidden="true" />
    </div>
    <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
      {cookie.description}
    </p>
    <div className="flex gap-2 flex-wrap">
      <p className="flex-1 min-w-0 font-body text-sm leading-[1.5] text-brand-neutral-900">
        <span className="font-bold">Maximum Storage Duration:</span>{' '}
        {cookie.duration}
      </p>
      <p className="flex-1 min-w-0 font-body text-sm leading-[1.5] text-brand-neutral-900">
        <span className="font-bold">Type:</span> {cookie.type}
      </p>
    </div>
  </div>
);

export default CookieItem;
